import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Registry } from '@/registry.service';
import { faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { BigBuyersModel } from '@/models/tables/big-buyers.model';
import { DialogBigBuyersComponent } from '@pages/tables/big-buyers/dialog-big-buyers/dialog-big-buyers.component';

@Component({
  selector: 'app-button-detail-big-buyers',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDetailBigBuyersComponent extends ButtonComponent implements OnInit {
  faIcon = faPenToSquare;
  private dialogOpened: MatDialogRef<any>;
  private bigBuyersModel: BigBuyersModel;
  private rowData: any;

  constructor(
    protected router: Router,
    protected toastr: ToastrService,
    private dialog: MatDialog,
  ) {
    super(router, toastr);

    this.showIcon = true;
    this.additionalClass = 'py-0.5 px-2.5';
    this.toolTip = 'Dettaglio Grande acquirente';
    this.smallBtn = true;
  }

  ngOnInit() {
    this.bigBuyersModel = <BigBuyersModel>this.rowData;
  }

  /**
   * Open modal new detail page
   */
  public actionClick(): void {
    this.dialogOpened = this.dialog.open(DialogBigBuyersComponent, {
      data: this.bigBuyersModel,
    });

    Registry.getInstance().set('DialogBigBuyersComponentModify', this.dialogOpened);
  }
}
